export const translation_2_4_A = {
  en: {},
  ko: {
    v1: {
      typography_0:
        "우리는 지금부터 부정적인 생각이나 감정을 마주할 때마다 '분리하기'를 적용하여 기록을 해나갈 거예요.",
      typography_1:
        "상황-생각-감정-신체 반응-행동, 이렇게 다섯 가지로 나눠서 기록할 건데요. 하나씩 보여드릴게요.",
      typography_2: "먼저 이건 '상황'이에요.",
      typography_2_1:
        "동료 몇 명이 함께 저녁 먹고 술 마시러 간다는 것을 들음",
      typography_3: "두 번째로 '생각'이에요.",
      typography_3_1:
        "난 이 집단의 일원이 아닌 것 같네. 내 동료들은 나를 좋아하지도 존중하지도 않는 것 같다.",
      typography_3_2: "70",
      typography_4: "세 번째로 '감정'이에요.",
      typography_4_1: "짜증, 슬픔, 분노",
      typography_5: "네 번째로 '신체 반응'이에요.",
      typography_5_1: "머리가 아픔, 배가 싸함",
      typography_6: "마지막으로 '행동'이에요.",
      typography_6_1:
        "오후 동안 사무실 자리에 앉아서 일어나지 않음",

      typography_7_0_0: "각 항목을 어떻게 분리하며 적어내는지 하나씩 배워볼게요.",

      typography_7: "상황은 어떻게 적나요?",
      typography_8:
        "첫째, 상황에는 당시의 객관적인 사실만 적어야 해요.",
      typography_8_1:
        "동료 몇 명이 함께 저녁 먹고 술 마시러 간다는 것을 우연찮게 들었음",
      typography_9:
        "나의 판단, 의견, 생각 등은 배제한 채 객관적으로 어떤 상황이 있었는지만 적어보는 거예요.",
      typography_10:
        "여기서 퀴즈를 하나 드려볼게요. 다음의 상황은 잘 적혔을까요?",
      typography_10_1:
        "계획한 공부는 하지 않고, 한심하게 휴대폰으로 SNS만 보고 있음",
      typography_quiz1_incorrect:
        "다시 한 번 생각해보세요. 적힌 문장에 판단, 의견, 생각은 없나요?",
      typography_11: `네, 정답이에요. 위의 상황은 객관적이지 않아요. "한심하게"라는 주관적인 판단이 들어가 있기 때문이죠.`,
      typography_12: `내가 내린 판단을 제외하고 아래처럼 객관적인 관점으로 적는 게 좋아요.`,
      typography_12_1: `계획한 공부 시간에 휴대폰으로 SNS를 보고 있음`,

      typography_12_2_0: `둘째, 상황은 선이 아닌 점처럼, 내게 부정적 반응을 일으킨 순간의 트리거를 적어야 해요.`,
      typography_12_2_1: `분리가 익숙해지기 전까지는 사건의 맥락은 포함시키지 않아야 합니다.`,
      typography_12_2_2: `과거에 어땠고 저쨌고 등은 적지 않아야 한다는 뜻입니다.`,
      typography_12_2_3: `맥락이 섞여 들어가면 상황은 모호해지고 주관적이게 될 확률이 높기 때문이에요.`,

      typography_12_3_0: `여기서 퀴즈를 하나 드려볼게요. 다음의 상황은 잘 적혔을까요?`,
      typography_12_3_1: `얼마 전 개인 면담에서 매니저가 내게 '더 할 수 있는데 안 하는 것 같다'고 함. 그런데 오늘 발표 후에 내게 다시 같은 피드백을 줌. 팀원들도 같이 있었고, 발표가 끝난 후 한 팀원이 내게 매니저가 사이코패스 아니냐며 괜찮냐고 물어옴.`,
      typography_quiz1_2_incorrect:
        "다시 한 번 생각해보세요. 적힌 상황이 길게 늘어뜰어져 있진 않나요?",
      typography_12_3_2: "네, 정답이에요. 위의 상황은 점이 아닌 선처럼 줄줄이 적혀 있어요.",
      typography_12_4_1: "가장 강렬한 부정적 반응을 자아낸 순간을 포착해서 아래처럼 적을 수 있어야 해요.",
      typography_12_4_2: "매니저가 내가 노력을 안 한다며, 팀원들과 함께 있는 자리에서 얘기함.",
      typography_12_5_1: "셋째, 내적 사건도 상황이 될 수 있어요.",
      typography_12_5_2: "\"동료가 내 인사에 답을 하지 않고 지나감\"과 같은 외적 사건만이 상황이 되는 것은 아닙니다.",
      typography_12_5_3: "\"자다가 눈을 떴는데, 어제 회사 미팅 장면이 떠오름\"과 같은 마음속에서 벌어진 내적 사건도 상황이 될 수 있습니다.",

      typography_13: "생각은 어떻게 적나요?",
      typography_14:
        "생각엔 당시의 그 상황에서 어떤 생각이 들었는지 적어주세요. 다음은 예시예요.",
      typography_14_1:
        "난 이 집단의 일원이 아닌 것 같네. 내 동료들은 나를 좋아하지도 존중하지도 않는 것 같다.",
      typography_14_1_0:
        "첫째, 상황에 적은 그 순간에 떠오른 생각을 독백 형태(예: ~하네, ~야, ~일 거야, ~할까)로 적어주세요.",
      typography_14_2: "70",
      typography_15:
        "누군가에게 말하는 형태(예: ~했어요, ~라고 느꼈어요)로 적는 건 좋지 않답니다.",

      typography_15_0_0:
        "여기서 퀴즈를 하나 드려볼게요. 다음의 생각은 잘 적혔을까요?",
      typography_15_0_1:
        "제가 비참했어요. 언제까지 이렇게 살아야 할지 막막했어요. 제가 힘들 때 도움을 거절했던 친구들이 생각나서 더 우울해졌어요.",
      typography_15_0_2: "70",
      typography_quiz2_0_incorrect:
        "다시 한 번 생각해보세요. 적힌 생각이 누군가에게 설명하는 형태로 적혀있진 않나요?",
      typography_15_0_3:
        "네, 정답이에요. 위의 생각은 마치 코치 선생님께 상담하는 것처럼 적혀있지요.",

      typography_15_0_4:
        "그 순간에 떠오른 생각을 독백 형태로 아래처럼 적어야 해요.",
      typography_15_0_5: "참 비참하네. 언제까지 이렇게 살아야 하는 걸까? 날 도와줄 사람들은 없어.",

      typography_16:
        "두 번째로 주의해야 할 것은 핵심적인 생각만 두세 문장으로 적어야 한다는 것이에요.",
      typography_16_0_1: "많은 사람들이 생각을 적으며 자신의 생각을 하염없이 털어놓곤 하는데요.",
      typography_16_0_2: "이는 잘못된 방식입니다.",
      typography_16_0_3: "분리하기는 '배출'이나 '곱씹기'가 아닙니다.",
      typography_16_0_4: "상황에 적은 그 찰나의 순간에, 내게 가장 큰 영향을 미친 생각을 두세 문장으로 추려서 적을 수 있어야 합니다.",

      typography_17:
        "여기서 퀴즈를 하나 드려볼게요. 다음의 생각은 잘 적혔을까요?",
      typography_17_1:
        "한달 째 제자리다. 이직을 원하던 회사의 면접에서 떨어지고 난 뒤, 아무것도 못하고 있네. 불합격 발표 날에도 엄마가 위로를 많이 해줬는데, 엄마한테 너무 미안하다. 내가 더 열심히 해야하는데, 왜 난 항상 제자리일까. 천성이 그냥 게으른 걸까. 진짜 이제는 뭘 해도 전부다 실패할 것만 같네. 어떡하냐..",
      typography_17_2: "70",
      typography_quiz2_incorrect:
        "다시 한 번 생각해보세요. 적힌 문장에서 핵심적인 생각들을 파악할 수 있겠나요?",
      typography_18:
        "네, 정답이에요. 위의 생각은 생각에 완전히 올라타서 허우적거리며 적힌 것이죠.",
      typography_19:
        "생각을 적을 때에는 '마음속에 떠오른 생각을 내가 관찰할 수 있다'는 점을 꼭 유념하며 아래처럼 적어야 해요.",
      typography_19_1: "엄마에게 너무 죄스럽네. 나는 게으른 사람이 분명해. 나는 앞으로 계속 실패만 할 거야.",
      typography_20: "그 당시 머리 속을 스쳤던 생각만, 날것 그대로 적어주세요.",
      typography_21:
        "그리고 그 아래 칸에는 당시 그 상황에서 떠올랐던 생각이 나에게 얼마나 부정적인 영향을 주는지 적어보는 거예요.",
      typography_22:
        "0은 전혀 영향 주지 않음을, 100은 그 생각으로 인해 나의 삶이 흔들릴 정도로 강하게 영향을 주었다는 걸 뜻해요.",

      typography_23: "감정은 어떻게 적나요?",
      typography_24:
        "감정에는 사건이 있었던 당시 느꼈던 감정을 적어주세요. 다음은 예시예요.",
      typography_24_1: "짜증, 슬픔, 분노",
      typography_25: "혹시 내가 느끼는 감정이 무엇인지 잘 모르겠다면, 일단은 인터넷에 '감정 단어'를 검색해서 참고해도 좋습니다.",

      typography_26: "신체 반응은 어떻게 적나요?",
      typography_27:
        "신체 반응에는 사건 당시 느꼈던 신체 감각을 적어주세요. 다음은 예시예요.",
      typography_27_1: "머리가 아픔, 배가 싸함",
      typography_28:
        "몸에서 느껴지는 신체 감각, 반사적인 반응 등을 적는 것이죠.",
      typography_28_0_1: "많은 분들이 신체 반응을 잘 적지 못하시고 \"없음\"이라고 적곤 하는데요.",
      typography_28_0_2: "그렇지 않습니다. 신체 반응은 없을 수가 없어요.",
      typography_28_0_3: "지금도 우리 몸에서는 수없이 많은 감각들이 느껴지고 있답니다.",
      typography_28_0_4: "가슴이 답답하거나, 머리가 지끈거리거나, 근육에 힘이 들어가는 등 모두 신체 반응의 예시이니 최대한 알아차려 적어볼 수 있도록 노력해보세요.",

      typography_29: "행동은 어떻게 적나요?",
      typography_30:
        "행동에는 그 사건을 겪은 후 어떤 식으로 행동했는지 적어주세요. 다음은 예시예요.",
      typography_30_1:
        "오후 동안 사무실 자리에 앉아서 일어나지 않음.",
      typography_31:
        "행동을 적을 때는 사건 직후에 이어진 행동을 적어도 괜찮고(예: 크게 소리치며 반응함)",
      typography_32: `그 사건으로 인해 하루종일 이어진 행동을 적어도 좋아요(예: 의기소침해져 하루종일 의견을 제대로 이야기하지 않음).`,

      typography_32_0_1: "다만 주의해야 할 점은, 앞서 적은 부정적 상황과 생각, 감정과 신체 반응의 결과로 발생한 행동을 적어주셔야 한다는 것입니다.",
      typography_32_0_2: "많은 분들이 행동에 '더 여유를 가져야 겠다고 다짐했다', '디스턴싱 앱을 켰다' 등을 적곤 하시는데요. 이는 적절히 적힌 게 아니랍니다.",
      typography_32_0_3: "내가 능동적으로 행한 행동보다는 수동적으로 행해질 수 밖에 없었던 부정적 경험의 결과를 적어주세요.",
      typography_32_0_4: "그래서 '충동'을 적어도 좋답니다.",

      typography_33_0_0: "이제 실전으로",
      typography_33: `어떤가요? 방법을 아니 크게 어려운 부분은 없으시죠?`,
      typography_33_0_1: `지금 알려드린 모든 내용을 기억할 필요는 없어요. <생각기록지>를 쓰면 코치 선생님이 확인하고 도와주실 테니까요.`,
      typography_34: `자, 그럼 이제 적으러 가볼까요?`,
    },
  },
};
